import { Component, Input } from '@angular/core';

@Component({
    selector: 'custom-menu',
    templateUrl: './custom-menu.component.html',
    styleUrls: ['./custom-menu.component.scss'],
    standalone: false
})
export class CustomMenuComponent {
  isMenuOpen = false;
  @Input() menuTitle: string;
  @Input() tooltip: string;

  toggleOpen(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }
}
